module.exports = __webpack_public_path__ + "static/media/metrics-no-data-es.e8679163.jpg";